import { useEffect, useCallback } from 'react';
import Globals from '../Globals';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
import UserService from '../services/UserService';

function AuthPage({ history, match, cookies }) {
    const parseJwt = useCallback(token => {
        let base64Url = token.split('.')[1];
        return JSON.parse(window.atob(base64Url));
    }, []);

    const getTokenUser = useCallback(
        async (accesToken, cookieOptions) => {
            const usuarioResponse = await new UserService().getUser(accesToken);
            if (usuarioResponse && usuarioResponse.statusCode === 200) {
                const data = JSON.parse(usuarioResponse.body.Result);
                cookies.set(Globals.COOKIES.USER, data.UserId, cookieOptions);
            }
            const jwt = parseJwt(accesToken); //Esto nos devuelve la informacion de dentro del JWT
            if (jwt.data) {
                console.log(jwt, 'JWT');
                const jwtData = JSON.parse(jwt.data);
                history.push(`/${jwtData.Path}`); //En nuestro caso le decimos donde quiere ir desde FS-Tools
            } else
                history.push({
                    pathname: `${Globals.APPLICATION_PATH.LOGIN}`,
                    state: {
                        pendingRefresh: true,
                    },
                }); // Aquí podríais poner Home, si siempre vais a ir alli
        },
        [cookies, history, parseJwt]
    );

    useEffect(() => {
        const { value: token } = match.params;
        let tokenJWT = JSON.parse(window.atob(token)); //Devuelve objeto tokenJWT
        // AQUÍ TOCARIA GUARDAR EN LA COOKIE O CUALQUIER SITIO QUE LO HAGAIS
        let tomorrow = new Date();
        tomorrow.setDate(
            tomorrow.getDate() + parseInt(process.env.REACT_APP_JWT_EXPIRES)
        );
        const cookieOptions = {
            path: process.env.PUBLIC_URL,
            expires: tomorrow,
            //maxAge: parseInt(process.env.REACT_APP_JWT_MAXAGE), //in milliseconds
            // secure: true,
            // httpOnly: true
        };
        cookies.set(Globals.COOKIES.JWT, tokenJWT, cookieOptions);

        getTokenUser(tokenJWT.AccessToken, cookieOptions); //set Token usrID
    }, [cookies, getTokenUser, match.params]);

    return null;
}

export default withCookies(withRouter(AuthPage));
